import { V1ExternalAccountInfo } from '@blk/portfolio-security-server/accountInfo';

import { ExistingExternalPortfolioMetaData, isPortfolioAssetDetailsResponse, PortfolioAssetDetailsResponse } from '../models/portfolio-holdings-resolution.model';

export class PortfolioHoldingsResolutionUtil {
	public static aggregateExistingPortfolioDataByPartnerAccountId(
		selectedPortfolios: (PortfolioAssetDetailsResponse | V1ExternalAccountInfo)[],
		userPortfolios: any,
		selectedPartnerId: string
	): Map<string, ExistingExternalPortfolioMetaData> {
		const accountIdKey: 'accountId' | 'id' = isPortfolioAssetDetailsResponse(selectedPortfolios[0]) ? 'accountId' : 'id';

		return selectedPortfolios.reduce((existingPortfolioDataByPartnerAccountId, selectedPortfolio) => {
			const matchingUserPortfolio: any = Object.values(userPortfolios).find((userPortfolio: any) =>
				userPortfolio.originPlatform?.platform === selectedPartnerId &&
				userPortfolio.encrypted?.originPartnerAccountId === selectedPortfolio[accountIdKey]
			);

			if (matchingUserPortfolio) {
				const accountId = selectedPortfolio[accountIdKey];
				existingPortfolioDataByPartnerAccountId.set(accountId, {
					name: matchingUserPortfolio.description,
					uniqueId: matchingUserPortfolio.uniqueId
				});
			}

			return existingPortfolioDataByPartnerAccountId;
		}, new Map());
	}
}
